import { render } from "./FormValidation.vue?vue&type=template&id=22328dd4"
import script from "./FormValidation.vue?vue&type=script&lang=js"
export * from "./FormValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__